'use client'

import cn from 'clsx'

import { ImageBox } from 'shared-components'
import { Swiper, SwiperSlide } from 'swiper/react'
import { A11y } from 'swiper/modules'
import { useRef } from 'react'

import 'swiper/css'
import 'swiper/css/pagination'

import s from './Gallery.module.sass'

function Gallery({ project }: any) {
    const { gallery } = project
    const sliderRef = useRef(null)

    if (!gallery?.length) return null;

    return (
        <section className={s.Gallery}>
            <div className={cn(s.Main, 'container')}>
                <Swiper
                    modules={[A11y]}
                    spaceBetween={10}
                    slidesPerView={1}
                    ref={sliderRef}
                    loop
                    breakpoints={{
                        1024: {
                            slidesPerView: 2
                        }
                    }}
                >
                    {gallery.map((item: any, index: number) => {
                        return (
                            <SwiperSlide key={index}>
                                <div className={s.GalleryImage}>
                                    <ImageBox image={item.image} />
                                    {item.caption && <p className={s.Caption}>{item.caption}</p>}
                                </div>
                            </SwiperSlide>
                        )
                    })}
                </Swiper>
            </div>
        </section>
    )
}

export default Gallery
